module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABYUlEQVQ4jZWSvUpjURSFvyQqSgSRSCSChY0/qIWPIEwjaC3TWGnjM4gWFjaioGBl5XRTTDFY+QA+gTOCleAMASdB1IC/ey85etVjjDHzwTqcsw973cU+l4CkjKR5SX8lVSTNSaKe3mDuW+auSPfmPtCwwZ1Z5c5MVdpoxKApLO6e5T1DpNM1ym95NDBXEShENzfA5qfdQPrJwPfNnUgTbS3NP//H4EeVwVgjzYFUWEqXlTbgBMgl9RIwmGvPlj9sTKVeE+Tas1fmvhol6DL3tYYThGcpnp2HFL+Avuh+ptDZ8a1egheDwEn57Auw91xPXmMKOARmgWtgqzfXeVHTIHD8r7wMLEQfs/CvAa3J+QAY78t3lV5mEGOuJXN9N1fYB2XM1RqdR8y1/W4GMUfF0xZgB5j+YHY+0NOdqZkg0F/I37r01aVFl8wlqrRbN0HM7z/F0WQmk8lQ14GV4d6ee4AH3SwuFz57thkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/health/information_phone.png
// module id = cqeS
// module chunks = 4